import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {TargetGroupsDetailsService} from './services/target-groups-details.service';

import {UserRole} from 'classes/user-role';
import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {Category} from 'shared/models/target-groups/category';
import {Company} from 'shared/models/target-groups/company';
import {Group} from 'shared/models/target-groups/group';
import {ManagementLevel} from 'shared/models/target-groups/management-level';
import {TargetGroup, TARGETGROUP_DUMMIES} from 'shared/models/target-groups/target-group';
import { TreeViewService } from 'app/modules/dynamic-tips/tree-view/services/tree-view.service';
import { Question } from 'shared/models/questions/question';

@Component({
  selector: 'target-groups-details',
  templateUrl: './target-groups-details.component.html',
  styleUrls: ['./target-groups-details.component.css'],

})

export class TargetGroupsDetailsComponent implements OnInit {

  public targetGroup: TargetGroup = new TargetGroup();
  public allRoles: Array<UserRole>;
  public selectedRole: UserRole;
  public allCategories: Array<Category>;
  public selectedCategory: Category;
  public allCompanies: Array<Company>;
  public selectedCompany: Company;
  public allGroups: Array<Group>;
  public selectedGroup: Group;
  public allMLevel: Array<ManagementLevel>;
  public allfirstOrderTips: Question; // question with button list
  private allTargetGroups: Array<TargetGroup>;
  public selectedMLevel: ManagementLevel;
  public gender: String;
  public minAge: number;
  public maxAge: number;

  public firstOrderUsed:Array<string> = ['The', 'possibilities', 'are', 'endless!'];
  public firstOrderRemains:Array<string> = ['Explore', 'them'];
  @ViewChild('deleteModal') public deleteModal: ModalConfirmationComponent;

  constructor(private targetGroupsDetailsService: TargetGroupsDetailsService,
              private treeViewService: TreeViewService,
              private activatedRoute: ActivatedRoute,
              private router: Router) { }

  public ngOnInit(): void {
    this.getAllRoles();
    this.getAllCategories();
    this.getAllCompanies();
    this.getAllGroups();
    this.getAllMLevel();
    this.getAllFirstOrderTips();
    this.getAllTargetGroups();
    
    this.activatedRoute.params.map((params) => params['targetGroupId'])
      .subscribe((targetGroupId: String) => {
        if (targetGroupId) {
          this.getTargetGroup(targetGroupId);
        }
      });
  }

  public saveTargetGroup(): void {
    // check if name already exists
    const old = this.allTargetGroups.filter(tg => tg.title.toLowerCase() === this.targetGroup.title.toLowerCase());
    if ( old.length > 0 ) {
      alert("Der Name '" + old[0].title + "' wird bereits verwendet.");
      return;
    }

    if (this.targetGroup.sex === 'none') {
      this.targetGroup.sex = null;
    }
    this.collectFirstOrderTips();
    this.targetGroupsDetailsService.createTargetGroup(this.targetGroup)
      .subscribe((createdTargetGroup: TargetGroup) => {
        this.router.navigateByUrl('targetgroups/list');
      });
  }

  public updateTargetGroup(): void {
    if (this.targetGroup.sex === 'none') {
      this.targetGroup.sex = null;
    }
    this.collectFirstOrderTips();
    this.targetGroupsDetailsService.updateTargetGroup(this.targetGroup)
      .subscribe((updatedTargetGroup: TargetGroup) => {
        this.router.navigateByUrl('targetgroups/list');
      });
  }

  public deleteTargetGroup(): void {
    this.targetGroupsDetailsService.deleteTargetGroup(this.targetGroup)
      .subscribe((status: boolean) => {
        this.router.navigateByUrl('targetgroups/list');
      });
  }

  public selectGroup(group: Group): void {
    this.targetGroup.groups.push(group);
    this.allGroups.splice(this.allGroups.indexOf(group), 1);
  }

  public deselectGroup(group: Group): void {
    this.allGroups.push(group);
    this.targetGroup.groups.splice(this.targetGroup.groups.indexOf(group), 1);
  }

  public selectCategory(category: Category): void {
    this.targetGroup.categories.push(category);
    this.allCategories.splice(this.allCategories.indexOf(category), 1);
  }

  public deselectCategory(category: Category): void {
    this.allCategories.push(category);
    this.targetGroup.categories.splice(this.targetGroup.categories.indexOf(category), 1);
  }

  public selectRole(role: UserRole): void {
    this.targetGroup.roles.push(role);
    this.allRoles.splice(this.allRoles.indexOf(role), 1);
  }

  public deselectRole(role: UserRole): void {
    this.allRoles.push(role);
    this.targetGroup.roles.splice(this.targetGroup.roles.indexOf(role), 1);
  }

  public selectCompany(company: Company): void {
    this.targetGroup.companies.push(company);
    this.allCompanies.splice(this.allCompanies.indexOf(company), 1);
  }

  public deselectCompany(company: Company): void {
    this.allCompanies.push(company);
    this.targetGroup.companies.splice(this.targetGroup.companies.indexOf(company), 1);
  }

  public selectMLevel(level: ManagementLevel): void {
    this.targetGroup.managementLevel.push(level);
    this.allMLevel.splice(this.allMLevel.indexOf(level), 1);
  }

  public deselectMLevel(level: ManagementLevel): void {
    this.allMLevel.push(level);
    this.targetGroup.managementLevel.splice(this.targetGroup.managementLevel.indexOf(level), 1);
  };

  public showDeleteModal(id: String): void {
    const content: string = `Sind Sie wirklich sicher, dass Sie diese Zielgruppe löschen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(id)
      .show();
  }

  private prepareDataForTargetGroup(targetGroup: TargetGroup): void {
    targetGroup.managementLevel.forEach((mlevel: ManagementLevel) => {
      this.allMLevel.splice(this.allMLevel.indexOf(mlevel), 1);
    });
    targetGroup.companies.forEach((company: Company) => {
      this.allCompanies.splice(this.allCompanies.indexOf(company), 1);
    });
    targetGroup.roles.forEach((role: UserRole) => {
      this.allRoles.splice(this.allRoles.indexOf(role), 1);
    });
    targetGroup.categories.forEach((category: Category) => {
      this.allCategories.splice(this.allCategories.indexOf(category), 1);
    });
    targetGroup.groups.forEach((group: Group) => {
      this.allGroups.splice(this.allGroups.indexOf(group), 1);
    });
    if (this.allfirstOrderTips) {
      this.prepareFirstOrderTips(targetGroup);
    }
  }

  private prepareFirstOrderTips(targetGroup: TargetGroup): void {
    this.firstOrderUsed = [];
    this.firstOrderRemains = [];
    const tipHash: Dictionary<string> = {};
    this.allfirstOrderTips.type['buttons'].forEach((txt, i) => {
      tipHash[''+i] = '<span id="'+i+'"></span>'+txt.de;
    });
    if (targetGroup._id === undefined) {
      this.firstOrderUsed = [];
      this.firstOrderRemains = Object.keys(tipHash).map(i => tipHash[i]);
    }
    else if (targetGroup.firstOrderTips === undefined) {
      this.firstOrderUsed = Object.keys(tipHash).map(i => tipHash[i]);
    }
    else {
      targetGroup.firstOrderTips.forEach(i => {
        this.firstOrderUsed.push(tipHash[''+i]);
        delete tipHash[''+i];
      })
      this.firstOrderRemains = Object.keys(tipHash).map(i => tipHash[i]);
    }
  }

  private collectFirstOrderTips(): void {
    this.targetGroup.firstOrderTips = this.firstOrderUsed.map(s => {
      let a = /^<span id="(\d+)"><\/span>/;
      const b = a.exec(s);
      return  b.length > 0 ? parseInt(b[1]) : -1;
    })
  }


  private getTargetGroup(id: String): void {
    this.targetGroupsDetailsService.getTargetGroup(id)
      .subscribe((targetGroup: TargetGroup) => {
        this.targetGroup = targetGroup;
        this.prepareDataForTargetGroup(this.targetGroup);
      });
  }

  private getAllRoles(): void {
    this.targetGroupsDetailsService.getAllRoles()
      .subscribe((allRoles: Array<UserRole>) => {
        this.allRoles = allRoles;
      });
  }

  private getAllCategories(): void {
    this.targetGroupsDetailsService.getAllCategories()
      .subscribe((allCategories: Array<Group>) => {
        this.allCategories = allCategories;
      });
  }

  private getAllCompanies(): void {
    this.targetGroupsDetailsService.getAllCompanies()
      .subscribe((allCompanies: Array<Company>) => {
        this.allCompanies = allCompanies.filter((company) => { return !TARGETGROUP_DUMMIES.includes(company.name)});
      });
  }

  private getAllGroups(): void {
    this.targetGroupsDetailsService.getAllGroups()
      .subscribe((allGroups: Array<Group>) => {
        this.allGroups = allGroups;
      });
  }

  private getAllMLevel(): void {
    this.targetGroupsDetailsService.getAllManagementLevel()
      .subscribe((allMLevel: Array<ManagementLevel>) => {
        this.allMLevel = allMLevel;
      });
  }

  private getAllFirstOrderTips(): void {
    this.targetGroupsDetailsService.getAllFirstOrderTips()
      .subscribe((allfirstOrderTips: Question) => {
        this.allfirstOrderTips = allfirstOrderTips;
        this.prepareFirstOrderTips(this.targetGroup);
      });
  }

  public getAllTargetGroups(): void {
    this.targetGroupsDetailsService.getAllTargetGroups()
      .subscribe((allTargetGroups: Array<TargetGroup>) => {
        this.allTargetGroups = allTargetGroups.filter((group) => { return !TARGETGROUP_DUMMIES.includes(group.title)});
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/target-groups-details/target-groups-details.component.ts